export default "__VITE_ASSET__lNfp7wWM__"